import React, {useRef, useState} from 'react';
import {IonButton, IonIcon, IonInput, IonItem, IonLabel, IonProgressBar} from "@ionic/react";
import {attachOutline} from "ionicons/icons";
import {FileInputProps} from "./index";
import {maxUploadSize} from "../../config";
import classNames from "classnames";
import styles from './styles.module.css';
import {useAppDispatch} from "../../lib/hooks";
import {actions} from "../../lib/app";

interface FileInputWebProps extends FileInputProps {
}

const FileInputWeb: React.FC<FileInputWebProps> = (props) => {
  const {state, accept} = props;
  const dispatch = useAppDispatch();
  const {value} = state;
  const inputRef = useRef<any>(null);
  const [file, setFile] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const onClick = () => {
    if (inputRef && inputRef.current)
      inputRef.current.click();
  }

  const onChange = (e: any) => {
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0];
      // console.log(file);

      // verificar tamanho máximo
      if (file.size > maxUploadSize) {
        const maxPermitido = (maxUploadSize / 1024 / 1024).toFixed(0);
        dispatch(actions.notifyError(`O tamanho deste arquivo ultrapassa o máximo permitido para anexos (${maxPermitido} Mb).`));
        return;
      }
      setLoading(true);
      let reader = new FileReader();

      reader.onprogress = function (event) {
        setProgress(event.loaded / event.total);
      };

      reader.onload = function () {
        setLoading(false);
        setFile(file);
        props.onChange(props.definition.name, {
          file: file,
          content: reader.result,
        });
      };

      reader.onerror = function () {
        setLoading(false);
        dispatch(actions.notifyError(`Erro ao ler o arquivo: ${reader.error}`));
      };
      reader.readAsBinaryString(file);
    }
  }

  return (
    <div className="flex flex-col w-full">
      <IonItem
        disabled={props.disabled}
        className={classNames("cursor-pointer")}
        button={true}
        detail={false}
        onClick={onClick}
      >
        <IonLabel
          position={props.labelPosition || 'floating'}
        >
          <span className={(props.state.touched && props.state.hasError) ? "text-red-600" : ""}>
            {props.definition.label} {props.definition.required && '*'}
          </span>
        </IonLabel>
        <input
          accept={accept}
          hidden
          ref={inputRef}
          type="file"
          onChange={onChange}
        />

        <IonInput
          value={file ? file.name : value.name}
          readonly={true}
          disabled={props.disabled || loading}
          className="cursor-pointer"
        />
        <div className="-mr-2" slot="end">
          <IonButton
              color="medium"
              fill="outline"
              size="default"
              className={classNames("app-button", styles.btAttachWeb)}
            >
              <IonIcon icon={attachOutline} slot="icon-only" />
          </IonButton>
        </div>
      </IonItem>
      <div className="h-1">
        {loading &&
        <IonProgressBar value={progress}/>
        }
      </div>
    </div>
  );
}

export default FileInputWeb;
